import React from 'react';

function Header() {
  return (
    <header>
      <h1>🎓 Student Info Manager</h1>
      <p>Manage student records easily with a clean UI.</p>
    </header>
  );
}

export default Header;
